// @ vendors
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const moment = require('moment');
const momentTz = require('moment-timezone');
const get = require('lodash/object/get');
const reduce = require('lodash/collection/reduce');
const trim = require('lodash/string/trim');
const Immutable = require('immutable');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { formatText } = require('core/i18n').i18n;

// @ actions
const errorActions = require('actions/brokerError');

// @ constants
const actionTypes = require('constants/actionTypes');
const {

    BROKER_EMPLOYEE_ID,
    FIRST_STEP,
} = require('constants/index');

const { COUNTRIES_CODES: { DE, PT } } = require('constants/countries');


const setAmountContribution = amount => ({
    type: actionTypes.BROKER_WIZARD_HIRE_INVESTMENT_CONTRIBUTION_SET_AMOUNT,
    payload: amount
})

const setPeriodicityContribution = periodicity => (dispatch) => {
    dispatch({
      type: actionTypes.BROKER_WIZARD_HIRE_INVESTMENT_CONTRIBUTION_SET_PERIODICITY,
      payload: periodicity,
    });
}

const setDateContribution = periodicity => (dispatch) => {
    dispatch({
      type: actionTypes.BROKER_WIZARD_HIRE_INVESTMENT_CONTRIBUTION_SET_DATE,
      payload: periodicity,
    });
}

const setDatePickerError = (error) => {
    return {
        type: actionTypes.BROKER_WIZARD_HIRE_INVESTMENT_CONTRIBUTION_DATEPICKER_ERROR,
        payload: {
            isValidDate: false
        }
    }
}

const reset = () => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_RESET
});

const setAccountNumber = (accountId, accountAmount, linkedToRobo) => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_SET_ACCOUNT_NUMBER,
    payload: {
        accountId,
        accountAmount,
        linkedToRobo,
    }
});

const setVisibleStep = step => {
    return ({
        type: actionTypes.BROKER_WIZARD_HIRE_INVESTMENT_CONTRIBUTION_SET_VISIBLE_STEP,
        payload: {
            step
        }
    })
};

const setWillLeave = () => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_WILL_LEAVE
});

const setWillCancel = willCancel => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_CHANGE_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const subscriptionSuccess = (hiredFunds) => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_CHANGE_SUCCESS,
    payload: { hiredFunds }
});

const changeAuth = auth => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_CHANGE_AUTHORIZATION,
    payload: {
        auth
    }
});

const changeReadChecked = checked => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_CHANGE_READCHECKED,
    payload: {
        checked
    }
});

const setAmount = amount => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_SET_AMOUNT,
    payload: {
        amount
    }
});

const setCustomMinimumAdditionalPurchaseAmount = (customMinimumAdditionalPurchaseAmount) => (dispatch) => {
    dispatch({
        type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_SET_CUSTOM_MINIMUM_ADDITIONAL_PURCHASE_AMOUNT,
        payload: customMinimumAdditionalPurchaseAmount
    });
}

const addIntervener = () => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_ADD_INTERVENER
});

const removeIntervener = (index, originalInterveners) => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_REMOVE_INTERVENER,
    payload: {
        index,
        originalInterveners
    }
});

const setIntervenerName = (index, name, originalInterveners) => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_SET_ACCOUNT_INTERVENER_NAME,
    payload: {
        index,
        name,
        originalInterveners
    }
});

const setIntervenerType = (index, type) => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_SET_ACCOUNT_INTERVENER_TYPE,
    payload: {
        index,
        type
    }
});

const restoreDefaultInterveners = originalInterveners => ({
    type: actionTypes.BROKER_WIZARD_SUBSCRIPTION_RESTORE_DEFAULT_INTERVENERS,
    payload: {
        originalInterveners
    }
});

const postPreHireSuccess = (data, featureFlag) => ({
    type: actionTypes.FETCH_BROKER_PRE_HIRE_SUCCESS,
    payload: {
        data,
        featureFlag
    }
});

const setContract = (contractToChange) => ({
    type:actionTypes.BROKER_WIZARD_SUBSCRIPTION_CHANGE_CONTRACT,
    payload: contractToChange
});

const intervenersCountInitial = {
    '01': 0,
    '07': 0,
    '08': 0,
    '09': 0,
    '25': 0
};

const typeCount = inteveners => inteveners.reduce(
    (accumulator, intervener) => {
        accumulator[intervener.get('interventionType')] = accumulator[intervener.get('interventionType')] + 1;
        return accumulator;
    }, intervenersCountInitial
);

const postPreHire = (fundId, isShowExtantCost, history) => (dispatch, getState) => {
    const immInvestmentFunds = getState().investmentFunds;
    const amount = parseFloat(immInvestmentFunds.getIn(['steps', FIRST_STEP, 'amount'])).toFixed(2);
    const immAccounts = getState().accounts.get('byId');
    const immAccount = immAccounts.get(immInvestmentFunds.getIn(['steps', FIRST_STEP, 'accountNumber']));

    if (!immAccount) {
        return;
    }

    const contractNumber = immAccount.get('contractNumber');
    const productNumber = immAccount.get('product');
    const balanceAmount = immAccount.getIn(['balance', 'amount']).toFixed(2);
    const currency = immAccount.getIn(['balance', 'currency']);
    const type = fundId ? fundId.substring(0, 3): null;
    const subtype = fundId ? fundId.substring(4, 7): null;
    const today = moment().format('DD-MM-YYYY HH:mm:ss.SSSSSS');
    const interveners = immInvestmentFunds.getIn(['steps', FIRST_STEP, 'interveners']);
    const interventionForm = typeCount(interveners);
    const isin = immInvestmentFunds.getIn(['investmentFunds', 'isin']);

    const parsedInterveners = interveners.map(intervener => {
        const interventionType = intervener.get('interventionType');
        const interventionFormValue = interventionForm[interventionType]
        const interventionFormString = interventionFormValue < 10 ? `0${interventionFormValue}` : `${interventionFormValue}`;
        return {
            formaIntervencion: interventionFormString,
            intervencion: interventionType,
            numPersona: intervener.get('personNumber'),
            tipoPersona: intervener.get('personType')
        };
    });

    const cuentaSeleccionada = {
        numerodecontrato: contractNumber,
        producto: productNumber
    };
    const datos = {
        dato: parsedInterveners.toJS()
    };
    const importeDivision = {
        divisa: currency,
        importe: parseFloat(amount)
    };
    const saldoCuentaSeleccionada = {
        divisa: currency,
        importe: parseFloat(balanceAmount)
    };
    const query = {
        cuentaSeleccionada: cuentaSeleccionada,
        datos: datos,
        fechaOrden: today,
        importeDivision: importeDivision,
        numEmpleado: BROKER_EMPLOYEE_ID,
        saldoCuentaSeleccionada: saldoCuentaSeleccionada,
        subtipo: subtype,
        tipo: type
    }

    const requestData = {
        query: query
    };

    const requestExtantCost = {
        header: {
            version: 2
        },
        query: {
            ...query,
            isin: isin,
        }
    };

    const request = isShowExtantCost ? requestExtantCost : requestData;
    dispatch(requestInvestmentFundsPreInProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerPreHireInvestmentFund'), request)
        .then(response => dispatch(postPreHireSuccess(response, isShowExtantCost)), function(response) {
            dispatch(requestInvestmentFundsPreFailure(response.error));
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        })
        .catch(response => dispatch(requestInvestmentFundsPreFailure(response.error)));
};

const validateStep = step => ({
    type: actionTypes.BROKER_WIZARD_HIRE_INVESTMENT_CONTRIBUTION_CHANGE_VALIDATE_STEP,
    payload: {
        step
    }
});

const skipContributionStep = skip => ({
    type: actionTypes.BROKER_WIZARD_HIRE_INVESTMENT_CONTRIBUTION_SKIP_CONTRIBUTION_STEP,
    payload: skip
});



module.exports = {
    setAmountContribution,
    setCustomMinimumAdditionalPurchaseAmount,
    setPeriodicityContribution,
    setDateContribution,
    setDatePickerError,
    addIntervener,
    removeIntervener,
    restoreDefaultInterveners,
    reset,
    setVisibleStep,
    setWillCancel,
    setWillLeave,
    setAmount,
    setAccountNumber,
    setIntervenerName,
    setIntervenerType,
    validateStep,
    changeAuth,
    changeReadChecked,
    postPreHire,
    skipContributionStep
};
